import { isExcludeProductSelection, isIncludeProductSelection, ProductSelection } from './ProductSelectionTypes';
import { ProductMetaData } from '../../../models/Product';
import { Article, SubscriptionPeriodType } from '../../../models/Article';
import isEqual from 'lodash/isEqual';
import { LineItemKey } from '../../store/api';
import { LendingModel } from '../../../models/PriceTier';

export type ProductIdOrOptions =
    | string
    | {
          id: string;
          price?: {
              lendingModel?: LendingModel;
              termLimit?: number;
              usageLimit?: number;
          };
          subscriptionPeriodType?: SubscriptionPeriodType;
      };

export const getProductSelectionCount = (state: ProductSelection): number => {
    return isExcludeProductSelection(state) ? state.totalCount - state.excluded.length : state?.included.length ?? 0;
};

export const hasProductSelection = (state: ProductSelection) => !!state;

export function nothingSelected(state: ProductSelection) {
    return (
        !state ||
        (isExcludeProductSelection(state) && state.totalCount <= state.excluded.length) ||
        (isIncludeProductSelection(state) && state.included.length < 1)
    );
}

export function isSelected(
    productOrId: string | (ProductMetaData & Article),
    productSelection: ProductSelection
): boolean {
    const lineItemKey = mapToLineItemKey(productOrId);

    if (isIncludeProductSelection(productSelection)) {
        return !!productSelection.included.find(item => isEqual(item, lineItemKey));
    }

    if (isExcludeProductSelection(productSelection)) {
        return !productSelection.excluded.find(item => isEqual(item, lineItemKey));
    }

    return false;
}

export function mapToLineItemKey(productIdOrOptions: ProductIdOrOptions): LineItemKey {
    const {
        id: productId,
        price = undefined,
        subscriptionPeriodType = undefined
    } = typeof productIdOrOptions === 'string' ? { id: productIdOrOptions } : productIdOrOptions;

    const usageCondition = price
        ? {
              lendingModel: price.lendingModel,
              usageLimit: price.usageLimit,
              termLimit: price.termLimit
          }
        : undefined;

    return { productId, usageCondition, subscriptionPeriodType };
}
